import isBrowser from './isBrowser';
import { isDev } from './env';

const formComplete = (formId: string) => {
  if (isBrowser()) {
    window._zi = { formId, formLoadTimeout: 4000, development: isDev() };
    const zi = document.createElement('script');
    zi.id = 'ZoomInfoFormComplete-Marketing';
    zi.type = 'text/javascript';
    zi.async = true;
    zi.src = 'https://ws-assets.zoominfo.com/formcomplete.js';

    const script = document.getElementsByTagName('script')[0];
    script.parentNode?.insertBefore(zi, script);
  }

  return null;
};

export default formComplete;
